import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { MAX_CHART_DAY_RANGE } from '@src/screens/Events/models/constants'
import { Text } from '../base'

export const DateRangeWarning = () => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.container}>
      <Text type="large" bold style={styles.text}>
        To view the glucose graph, please select a date range of {MAX_CHART_DAY_RANGE} days or
        fewer.
      </Text>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  text: {
    textAlign: 'center',
    top: '50%',
    left: '50%',
    color: 'theme.text.primary',
    transform: [{ translateX: -150 }, { translateY: -20 }],
    width: 300,
  },
})
